import { FormHelperTextProps } from '@mui/material';
import { useContext } from 'react';
import { FieldContext } from './FieldContext';
export default function FormHelperText({children,error,id,className}:FormHelperTextProps) {
    const field=useContext(FieldContext), invalid=error ?? field?.error;
    return <div id={id || (field ? `${field.id}-hint` : undefined)} className={`${invalid ? 'invalid-feedback d-block' : 'form-text'} ${className || ''}`} role={invalid ? 'alert' : undefined}>{children}</div>;
}
